<template>
	<!-- <pre>{{ dbFilter }}</pre> -->
	<details 
    	class="dropdown-filter"
    	:data-default-label="dbFilter.label" 
    	:data-dt-id="dtPost.id"
    	:open="open"
    	v-click-out-side="clickOutside"
    	>
    	
        <summary class="summary-label" @click.prevent="dropdownToggle()">
        	<span v-if="filter.active" class="filters-count">1</span>
        	{{ dbFilter.label }}
        </summary>
        <div class="details-content">
            <form 
            	ref="ddf"
            	action="#" 
            	method="get" 
            	:id="`filter-type-${ i }`" 
            	@submit.prevent="filterSubmit"
            	@reset.prevent="filterReset"
            	>
                <DataviewFiltersDropdownOptions 
					:options="dbFilter.options"
					:themeLo="feTheme"
					:containerClass="side ? '' : null"
					:columnName="columnName"
					:dtPost="dtPost"
					:colIndex="i"
					:filterActive="filter.active"
					:open="open"
					@change="setFilter"
					@reset="resetFilter"
                	/>
            </form>
        </div>
    </details>
</template>


<script>
	import DataviewFiltersDropdownOptions from '@vueapp/components/dataviews/DataviewFiltersDropdownOptions.vue'
	import clickOutSide from "@mahdikhashan/vue3-click-outside"

	export default {
		components: {
			DataviewFiltersDropdownOptions
		},
		directives: {
			clickOutSide,
		},
		props: {
			dbFilter: Object,
			i: Number,
			feTheme: Object,
			dtPost: Object,
			side: Boolean,
			open: Boolean
		},
		emits: ['filter-submit', 'dropdown-open', 'dd-close'],
		data() {
			return {
				columnName: null,
				filterValue: null,
				filter: this.dbFilter
			}
		},
		created() {
			this.columnName = this.dbFilter.column_name
			// this.active = this.dbFilter.active
			if ( this.dbFilter.options == false ) {
				this.dbFilter.options = []
			}
		},
		updated() {
			// alert('x')
			// this.active = this.dbFilter.active
		},
		methods: {
			dropdownToggle() {
				let i = this.i,
					open = this.open
				this.$emit('dropdown-open', {
					i,
					open
				})
			},
			resetFilter() {
				this.filter.active = false
				this.$emit('filter-submit', {
							filterValue: null,
							filterKey: this.columnName
						})
			},	

			setFilter(value){ 
				this.filterValue = value.filterValue
			},

			filterSubmit(e) {
				this.filter.active = this.filterValue != null
				this.$emit('filter-submit', {
												filterValue: this.filterValue,
												filterKey: this.columnName
											})
			},

			clickOutside() {
				const i = this.i
				this.$emit('dd-close', {
					i
				})
			}

		},
		computed: {
			
		}
	}
</script>